import React from 'react';

export const TRACADO_DO_ARCO =
  'M38.8011 139.539C27.1187 126.421 20 109.004 20 89.8927C20 49.0829 52.4594 16 92.5 16C132.541 16 165 49.0829 165 89.8927C165 110.737 160.622 125.566 147 139';

export const PONTO_DA_MARCA = { cx: 92.5, cy: 157.5, rx: 22.5, ry: 23.5 } as const;

/**
 * A marca da Inside desenhada em `currentColor`, e não num arquivo `.svg` com
 * `white` cravado: como `<img>`, o CSS não alcança o traço, e o logotipo branco
 * sumia sobre o fundo claro. Inline, ele herda a cor de quem o coloca na tela e
 * funciona nos dois temas sem trocar de arquivo.
 *
 * A mesma geometria aparecia duplicada na tela de entrada e na de carregamento.
 */
export const MarcaInside: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 185 181" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      className="arco"
      d={TRACADO_DO_ARCO}
      stroke="currentColor"
      strokeWidth="30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse className="ponto" {...PONTO_DA_MARCA} fill="currentColor" />
  </svg>
);
